import styles from "./ErrorCard.module.scss";

interface IErrorCardProps {
  text: string
}
const ErrorCard:React.FC<IErrorCardProps> = ({text}) => {

  return (
    <div className={styles.root}>  
      {text}
    </div>
  );
};

export default ErrorCard;
